<template>
  <div class="tickets-tab">
    <h2>Tickets</h2>
    <!-- <div class="flex-sb">
      <div class="form-item">
        <span>Filter by Type</span>
        <v-checkbox-group
          v-model="type"
          :list="filterTypeOptions"
          @change="filterData" />
      </div>
      <div class="btn-container">
        <v-button
          :disabled="disabledBtn"
          @click="handlerClearSelection">Clear Selection</v-button>
        <v-button
          type="danger"
          :disabled="disabledBtn"
          @click="handlerSelected('unsnooze')">Unsnooze Now</v-button>
        <v-button
          type="success"
          :disabled="disabledBtn"
          @click="handlerSelected('resolved')">Mark As Resolved</v-button>
      </div>
    </div> -->
    <!-- <div>
      <el-table
        ref="table"
        :data="tableData"
        style="width: 100%"
        highlight-current-row
        :header-row-class-name="'tableHeader'"
        default-expand-all
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        @selection-change="handleSelectionChange"
        @row-click="rowClick">
        <el-table-column
          prop="id"
          width="40"
        >
          <template>
            <div class="flex-algin">
              <font-awesome-icon icon="ticket-alt"></font-awesome-icon>
            </div>
          </template>
        </el-table-column>
        <el-table-column   width="120">
          <template #default="{ row }">
            <div class="flex-algin">
              <p> <span class="span-status type-status">{{ row.type_language }}</span></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Subject"
          :show-overflow-tooltip="true"
          min-width="230">
          <template #default="{ row }">
            <div
              class="flex-algin"
              @click="rowClick(row)">
              <div class="flex flex-circle">
                <router-link
                  class="showLick"
                  :to="rowClickFn(row)">
                  {{ row.subject }}
                </router-link>
              </div>
              <p class="liter-text">{{ row.ticket_number }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="requester"
          :show-overflow-tooltip="true"
          label="Requester">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="text-span">{{ row.requester }}</span>
              <p class="liter-text">{{row.phone?row.phone:''}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="assignee"
          label="Assigned">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="text-span">{{ row.assignee }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Status & Stage"
          width="150px">
          <template #default="{ row }">
            <div class="flex-algin">
              <div>
                <i
                  class="status-height"
                  :class="{
                    'status-one':row.status==1,
                    'status-two':row.status==2,
                    'status-three':row.status==3
                  }">{{ row.status_language }}</i>
              </div>
              <p>
                <i
                  v-if="row.stts_language"
                  class="span-status-stts"
                  :class="{
                    'orange-light': [1, 3,5].includes(row.stts)&&row.type==2||row.type==3&&[101,301].includes(row.stts),
                    'yellow-dark':[0].includes(row.stts)&&row.type==2||row.type==4&&[1].includes(row.stts)||(row.type==5||row.type==6||row.type==3)&&[0].includes(row.stts),
                    'blue': [2,4].includes(row.stts)&&row.type==2||row.type==4&&[4].includes(row.stts)||row.type==3&&[201,501].includes(row.stts)||row.type==6&&[1].includes(row.stts),
                    'green': [6].includes(row.stts)&&row.type==2||row.type==4&&[2].includes(row.stts)||row.type==3&&[601].includes(row.stts)||row.type==5&&[1].includes(row.stts)||row.type==6&&[2].includes(row.stts),
                    'red': [6].includes(row.stts)&&row.type==3||row.type==4&&[3].includes(row.stts)||row.type==3&&[401].includes(row.stts),
                  }">{{ row.stts_language }}</i>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          width="160"
          label="Created">
          <template #default="{ row }">
            <span class="liter-time">{{ row.created_at.split(" ")[0] }}</span><br>
            <span class="liter-time"> {{ row.created_at.split(" ")[1] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div> -->
    <div
      v-if="tableData && tableData.length > 0"
      class="table">
      <div class="header flex">
        <div class="empty"></div>
        <div class="subject">Subject</div>
        <div class="requester">Requester</div>
        <div class="assignee">Assignee</div>
        <div class="status">Status & Stage</div>
        <div class="created">Created</div>
      </div>
      <div class="body">
        <div
          v-for="(item, i) in tableData"
          :key="i">
          <div class="time">Period: {{item.period}}</div>
          <div
            v-for="(subItem, index) in item.record"
            :key="index"
            class="flex content">
            <div class="empty">
              <font-awesome-icon
                icon="ticket-alt"
                class="icon"></font-awesome-icon>
              <p> <span class="span-status type-status">{{ subItem.type_language }}</span></p>
            </div>
            <div class="subject">
              <div
                class="flex-algin"
                @click="rowClick(subItem)">
                <div class="flex flex-circle">
                  <div
                    class="blue-circle"
                    :class="{'yellow-circle':subItem.is_snooze === 1,'blue':subItem.client_updated==1}"
                    @click.stop="handlerBluePoint(subItem.$index)">
                  </div>
                  <router-link
                    class="showLick"
                    :to="rowClickFn(subItem)">
                    {{ subItem.subject }}
                  </router-link>
                </div>
                <p class="liter-text">{{ subItem.ticket_number }}</p>
              </div>

            </div>
            <div class="requester">
              <div class="flex-algin">
                <span class="text-span">{{ subItem.requester }}</span>
                <p class="liter-text">{{subItem.phone?subItem.phone:''}}</p>
              </div>
            </div>
            <div class="assignee">
              <div class="flex-algin">
                <span class="text-span">{{ subItem.assignee }}</span>
              </div>
            </div>
            <div class="status">
              <div class="flex-algin">
                <div>
                  <i
                    class="status-height"
                    :class="{
                      'status-one':subItem.status==1,
                      'status-two':subItem.status==2,
                      'status-three':subItem.status==3
                    }">{{ subItem.status_language }}</i>
                </div>
                <p>
                  <i
                    v-if="subItem.stts_language"
                    class="span-status-stts"
                    :class="{
                      'orange-light': [1, 3,5].includes(subItem.stts)&&subItem.type==2||subItem.type==3&&[101,301].includes(subItem.stts),
                      'yellow-dark':[0].includes(subItem.stts)&&subItem.type==2||subItem.type==4&&[1].includes(subItem.stts)||(subItem.type==5||subItem.type==6||subItem.type==3)&&[0].includes(subItem.stts),
                      'blue': [2,4].includes(subItem.stts)&&subItem.type==2||subItem.type==4&&[4].includes(subItem.stts)||subItem.type==3&&[201,501].includes(subItem.stts)||subItem.type==6&&[1].includes(subItem.stts),
                      'green': [6].includes(subItem.stts)&&subItem.type==2||subItem.type==4&&[2].includes(subItem.stts)||subItem.type==3&&[601].includes(subItem.stts)||subItem.type==5&&[1].includes(subItem.stts)||subItem.type==6&&[2].includes(subItem.stts),
                      'red': [6].includes(subItem.stts)&&subItem.type==3||subItem.type==4&&[3].includes(subItem.stts)||subItem.type==3&&[401].includes(subItem.stts),
                    }">{{ subItem.stts_language }}</i>
                </p>
              </div>
            </div>
            <div class="created">
              <span class="liter-time">{{ subItem.created_at.split(" ")[0] }}</span><br>
              <span class="liter-time"> {{ subItem.created_at.split(" ")[1] }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!tableData || tableData.length == 0"
      class="tips" >
      <span>No Data</span>
    </div>
    <!-- <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" /> -->
  </div>
</template>
<script>
import { setResolvedTicket, setTicketUnsnooze } from '@/api/ticket'
import MixinOptions from '@/mixins/options'
export default {
  name: 'TicketsTab',
  mixins: [MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      }, 
      selectionTickets: [],
      type: [],
      filterTypeOptions: [
        // {
        //   id: 1,
        //   name: 'General'
        // },
        // {
        //   id: 3,
        //   name: 'Endorsement'
        // },
        {
          name: 'General',//一般,正常？？？
          id: 1
        },
        {
          name: 'Refer Case',//案例
          id: 2
        },
        {
          name: 'Endorsement',//认可
          id: 3
        },
        {
          name: 'Claims',
          id: 6
        }
      ]
    }
  },
  computed: {
    tableData() {
      return this.form.tickets
    },
    disabledBtn() {
      return this.selectionTickets.length <= 0
    }
  },
  watch: {
    form: {
      //   immediate: true,
      deep: true,
      handler(formData) {
        if(formData.ticket && formData.ticket.total){
          this.pageConfig.total = formData.ticket.total
        }
        if(formData.ticket && formData.ticket.current_page){
          if(this.pageConfig.currentPage != formData.ticket.current_page) {
            this.pageConfig.currentPage = formData.ticket.current_page
          }
        }
      }
    }
  },
  methods: {
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.handler().getData()
    },
    rowClick({ id }) {
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: id
        }
      })
    },
    rowClickFn(row){
      return({
        path: '/tickets/detail',
        query: {
          ticket_id: row.id
        }
      })
    },
    handleSelectionChange(val) {
      this.selectionTickets = val
    },
    handlerClearSelection() {
      this.$refs.table.clearSelection()
    },
    filterData() {
      this.handler().getData()
    },
    handlerSelected(type) {
      if(this.selectionTickets.length < 1) {
        return
      }
      const ticketId = this.selectionTickets.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      if(type === 'resolved') {
        this.network().setResolvedTicket(ticketId)
      } else {
        this.network().setTicketUnsnooze(ticketId)
      }
    },
    handler() {
      return {
        getData: () => {
          this.$emit('update-data', {
            page: this.pageConfig.currentPage,
            // ticket_size: '',
            ticket_type: this.type
          })
        }
      }
    },
    network() {
      return {
        setResolvedTicket: async (ticketId) => {
          const { data } = await setResolvedTicket({
            ticket_id: ticketId
          })
          this.handler().getData()
        },
        setTicketUnsnooze: async (ticketId) => {
          const { data } = await setTicketUnsnooze({
            ticket_id: ticketId
          })
          this.handler().getData()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.tickets-tab {
  position: relative;
  .btn-container {
      margin-bottom: 10px;
      text-align: right;
  }
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    height: 45px;
    th {
      background-color:#F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      color: #24292E;
      height: 45px;
      .cell{
        height: 30px;
      }
    }
  }
  .el-table{
    border-radius: 4px;
    border:1px solid #D1D5DA;
    ::v-deep .flex-algin{
      p,span{
        height: 24px;
      }
      .flex-circle{
        height: 24px;
        align-items: center;
        span{
          color: #24292E;
          font-size: 14px;
          font-weight: 600;
        }
      }
      p:first-child{
        color: #24292E;
        font-size: 14px;
        font-weight: 600;
        span{
          font-weight: 600;
        }
      }
    }
    .liter-time{
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      color: #24292E;
    }
    .liter-text{
      color: #6A737D;
      font-family: Inter;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 15px;
    }
    .text-span{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #24292E;
    }
    ::v-deep .el-table-column--selection{
      .cell{
        padding-left: 15px!important;
      }
    }
    ::v-deep td{
      padding: 10px 0!important;
      vertical-align: top;
    }
    ::v-deep .el-checkbox:last-of-type{
      margin-top: 4px;
    }
  }

  .table{
    .liter-time{
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      color: #24292E;
    }
    .liter-text{
      color: #6A737D;
      font-family: Inter;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 15px;
    }
    .text-span{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #24292E;
    }
    .header{
      background: #F6F8FA;
      height: 45px;
      border: 1px solid #D1D5DA;
      border-radius: 6px 6px 0px 0px;
      div{
        display: flex;
        align-items: center;
        background: #F6F8FA;
        font-weight: 600;
        border-radius: 6px 6px 0px 0px;
        font-size: 14px;
        letter-spacing: -0.15px;
        color: #24292E;
        font-family: 'inter';
      }
    }
    .body{
      background: #ffffff;
      font-size: 14px;
    }
    .empty,.requester,.assignee,.status,.created{
      flex: 1;
    }
    .subject{
      flex: 2;
    }
    .empty{
      display: flex;
      justify-content: space-around;
      align-items: center;
      color: #606266;
      p{
        line-height: 1;
        color: #24292E;
      }
    }
    .time{
      background: #FAFBFC;
      border-bottom: 1px solid #D1D5DA;
      height: 45px;
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 14px;
      padding-left: 15px;
      border: 1px solid #D1D5DA;
      border-top: 0;
      font-family: 'inter';
    }
    .content{
      padding: 15px 0;
      border: 1px solid #D1D5DA;
      border-top: 0;
    }
    .span-status {
      margin-right: 5px;
      padding: 0 8px;
      border-radius: 25px;
      white-space: nowrap;

      height: 18px;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      color: #24292E;
      &.success {
        color:  rgb(67, 181, 92);
        background: rgb(220, 255, 228);
      }
      &.warning {
        background: rgb(255, 245, 177);
        color: rgb(218, 193, 93);
      }
      &.error {
        background: rgb(215, 58, 73);
        color: white;
      }
      &.warning-plain {
        border: 1px solid #B08800;
        color: #B08800;
      }
      &.unread-uplod {
        border: 1px solid #0366D6;
        color: #0366D6;
      }
      &.type-status{
        border: 1px solid #E1E4E8;
        color: #24292E;
      }
    }
    .status-height{
      height: 18px;
      line-height: 18px;
      padding: 0px 10px;
    }
    .status-two{
      border: 1px solid #0366D6;
      color: #0366D6;
      display: inline-block;
      padding: 0px 8px;
      font-size: 12px;
      border-radius: 50px;
      height: 18px;
      line-height: 18px;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
    }
    .status-one{
      border: 1px solid #735C0F;
      color: #735C0F;
      display: inline-block;
      padding: 0px 8px;
      font-size: 12px;
      border-radius: 50px;
      height: 18px;
      line-height: 18px;
      font-style: normal;
      font-weight: 600;
    }
    .status-three{
      border: 1px solid #22863A;
      color: #22863A;
      display: inline-block;
      padding: 0px 8px;
      font-size: 12px;
      border-radius: 50px;
      height: 18px;
      line-height: 18px;
      font-style: normal;
      font-weight: 600;
    }
    .span-status-stts{
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      display: inline-block;
      color: #FFFFFF;
      padding: 0px 8px;
      height: 18px;

      border-radius: 100px;
      &.orange-light {
        background: #E36209;
      }
      &.yellow-dark {
        background: #DBAB09;
      }
      &.blue {
        background: #0366D6;
      }
      &.green {
        background: #28A745;
      }
      &.red {
        background: #D73A49;
      }
      &.purple {
        background: #6F42C1;
      }

    }
    .flex-aglin{
      display: flex;
      flex-direction: column;
      justify-content:space-between ;
      p{
        height: 24px;
      }
      p:first-child{
        color: #24292E;
        font-size: 14px;
        font-weight: 600;
      }
    }
    .liter-text{
      color: #6A737D;
      font-family: Inter;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 18px;
      height: 18px;
    }

    .text-right{
      position: absolute;
      z-index: 100;
      right: 1px;
      margin-top: 6px;
      height: 40px;
      width: 90%;
      background-color:#F6F8FA !important;
    }
    .showLick{
      color:  #000;
      text-decoration: none;
      &:hover{
        color:  #0366D6;
      }
    }
  }
  .tips {
    padding-top: 50px;
    font-size: 14px;
    text-align: center;
  }
}
</style>